import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-palumbo-black flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-12 justify-center">
          <span className="w-10 h-10 bg-palumbo-copper flex items-center justify-center font-display font-black text-black text-lg">P</span>
          <div>
            <div className="font-display text-white font-extrabold uppercase tracking-tight">Palumbo</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-palumbo-copper">Custom Garage</div>
          </div>
        </div>

        <div className="bg-palumbo-dark border border-white/10 p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <Lock size={20} strokeWidth={1.5} className="text-palumbo-copper" />
            <h1 className="font-display font-bold text-2xl uppercase tracking-tight">Area Riservata</h1>
          </div>

          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label className="text-[10px] uppercase tracking-[0.25em] text-neutral-400 block mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                className="w-full bg-palumbo-black border border-white/15 focus:border-palumbo-copper outline-none px-4 py-3 text-white text-sm"
                placeholder="admin@palumbocustomgarage.it"
              />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-[0.25em] text-neutral-400 block mb-2">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                className="w-full bg-palumbo-black border border-white/15 focus:border-palumbo-copper outline-none px-4 py-3 text-white text-sm"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div data-testid="admin-login-error" className="border border-red-500/30 bg-red-500/10 text-red-400 text-xs px-4 py-3 uppercase tracking-wide">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-palumbo-copper hover:bg-palumbo-copper-dark disabled:opacity-60 text-white font-bold uppercase tracking-wide px-8 py-4 text-sm transition-colors"
            >
              {loading ? "Accesso..." : <>Accedi <ArrowRight size={16} /></>}
            </button>
          </form>
        </div>

        <p className="text-center text-xs uppercase tracking-widest text-neutral-600 mt-8">
          <a href="/" className="hover:text-palumbo-copper">← Torna al sito</a>
        </p>
      </div>
    </div>
  );
}
